import { PersonStatusTier } from '@on3/api';
import { On3Plus } from '@on3/ui-lib/components/Svg/On3Plus';

import styles, { black, green } from './VerifiedBadge.module.scss';

interface VerifiedBadgeProps {
  tier?: PersonStatusTier;
  colors?: string[];
}

export const VerifiedBadge = ({
  tier = PersonStatusTier.Unknown,
  colors = [green, black],
}: VerifiedBadgeProps) => {
  let badge = 'Verified';

  if (tier === PersonStatusTier.Base) {
    badge = 'Recruit';
  }

  if (tier === PersonStatusTier.Star || tier === PersonStatusTier.Elite) {
    badge = 'Elite';
  }

  return (
    <div className={styles.block}>
      <On3Plus colors={colors} />
      <span className={styles.tier}>{badge}</span>
    </div>
  );
};
